module.exports = __webpack_public_path__ + "be59292ec0c1f33c8453824c954c0475.png";